import React, { useEffect, useCallback } from "react";
import TextOverlay from "./TextOverlay";
import { StyledAutoComplete, StyledTextField } from "./CommonStyles";

const AutoCompleteFibre = ({
  options = [],
  name,
  setFieldValue,
  garmentFibre = {},
  disabled = false,
  errorBorder = "",
  showAlias = "N",
  onChange = () => {},
}) => {
  const { garment = "", fibre = "" } = garmentFibre;

  const shouldHideFibre = useCallback(
    (value) => value?.includes("%"),
    []
  );

  useEffect(() => {
    onChange(shouldHideFibre(fibre));
  }, [fibre, onChange, shouldHideFibre]);

  // Ensure empty option is present
  const normalizedOptions = options.some(
    (opt) => opt.value === "" && opt.label === ""
  )
    ? options
    : [{ label: "", value: "" }, ...options];

  // Find the selected option object based on garment or fibre value
  const selectedValue =
    normalizedOptions.find(
      (opt) => opt.value === (garment || fibre)
    ) || { label: "", value: "" };

  const handleChange = (e, option) => {
    const value = option?.value || "";
    onChange(shouldHideFibre(value));
    setFieldValue(name, value);
  };

  return (
    <TextOverlay text={showAlias === "Y" ? selectedValue.value : selectedValue.label}>
      <StyledAutoComplete
        fullWidth
        size="small"
        disableClearable
        options={normalizedOptions}
        getOptionLabel={(option) =>
          showAlias === "Y" && option?.label?.length > 0
            ? option?.value
            : option?.label
        }
        renderInput={(params) => <StyledTextField {...params} />}
        className={`autocomplete_fiber ${errorBorder}`}
        onChange={handleChange}
        name={name}
        value={selectedValue}
        disabled={disabled}
        isOptionEqualToValue={(option, value) => option.value === value.value}
      />
    </TextOverlay>
  );
};

export default AutoCompleteFibre;
